<div class="wrapper header">

  <div class="queueTitle">{{radioQueueTitle$ | async}}</div>

  <button class="icon-button" (click)="onRefresh()">
    <tun-refresh-icon-v5 class="icon icon-scaled-svg-button"></tun-refresh-icon-v5>
  </button>

</div>
